import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { LotPopupService } from './lot-popup.service';
import { InventoryUnit } from '../../inventory-manager/inventory-unit.model';
import { MANAGE_LOT_PERMISSIONS } from '../../shared/auth/permissions';
import { AlertService } from '../../shared/alert/alert.service';
import { JhiEventManager } from '../../shared/core-utils';
import { NgClass, NgStyle } from '@angular/common';
import { InventoryService } from '../../shared/inventory/service/inventory.service';
import { LotService } from '../../shared/inventory/service/lot.service';
import { TransactionService } from '../../shared/inventory/service/transaction.service';
import { Lot } from '../../shared/inventory/model/lot.model';
import { Transaction } from '../../shared/inventory/model/transaction.model';
import { SubscriptionsManager } from '../../shared/util/subscriptions-manager';

@Component({
    selector: 'jhi-lot-create-dialog',
    templateUrl: './lot-create-dialog.component.html'
})
export class LotCreateDialogComponent implements OnInit, OnDestroy {
    SEED_AMOUNT_UNDEFINED = 'SEED_AMOUNT_UNDEFINED';
    CREATE_DEPOSIT_INVENTORY_PERMISSION = [...MANAGE_LOT_PERMISSIONS, 'DEPOSIT_INVENTORY', 'CREATE_CONFIRMED_DEPOSITS'];

    lot: Lot;
    model;
    deposit: Transaction;
    initialDeposit = false;
    units: Promise<InventoryUnit[]>;
    unitsVariables: InventoryUnit[];
    storageLocationId: number;
    isSeedAmountUndefined = false;
    subscriptionsManager = new SubscriptionsManager();

    constructor(private activatedRoute: ActivatedRoute,
                private transactionService: TransactionService,
                private inventoryService: InventoryService,
                private alertService: AlertService,
                public activeModal: NgbActiveModal,
                private lotService: LotService,
                private eventManager: JhiEventManager
    ) {
        this.model = { stockIdPrefix: '' };
        this.lot = new Lot();
        this.deposit = new Transaction();
        this.deposit.transactionType = 'Deposit';
        this.deposit.transactionStatus = 'Confirmed';

        this.units = this.inventoryService.queryUnits().toPromise();
        this.units.then((units) => this.unitsVariables = units);
        this.lot.unitId = 0;

    }

    ngOnInit() {
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.lot.locationId = this.storageLocationId;
        this.subscriptionsManager.add = this.lotService.create(this.lot, this.model.stockIdPrefix).subscribe(
            (res) => this.createDeposit(res));
    }

    isInvalid() {
        return isNaN(this.storageLocationId);
    }

    unitChanged() {
        const seedAmountUndefinedUnit = this.unitsVariables.find((unit) => unit.name === this.SEED_AMOUNT_UNDEFINED);

        if (seedAmountUndefinedUnit.id === String(this.lot.unitId)) {
            this.isSeedAmountUndefined = true;
            this.deposit.amount = 0;
        } else {
            this.isSeedAmountUndefined = false;
            this.deposit.amount = null;
        }
    }

    private createDeposit(lotUUID: any) {
        this.lot.lotUUID = lotUUID;
        if (this.initialDeposit) {
            const lotDepositRequest = {
                selectedLots: { searchRequest: null, itemIds: [lotUUID] },
                notes: this.deposit.notes,
                depositsPerUnit: {}
            };
            this.units.then((units) => {
                const lotUnit = units.filter((unit) => unit.id === this.lot.unitId.toString());
                lotDepositRequest.depositsPerUnit[lotUnit[0].name] = this.deposit.amount;
                if (lotUnit[0].name === this.SEED_AMOUNT_UNDEFINED) {
                    this.subscriptionsManager.add = this.transactionService.createPendingDeposits(lotDepositRequest).subscribe((res: HttpResponse<Lot>) =>
                        this.onSaveSuccess(res));
                } else {
                    this.subscriptionsManager.add = this.transactionService.createConfirmedDeposits(lotDepositRequest).subscribe((res: HttpResponse<Lot>) =>
                        this.onSaveSuccess(res));
                }
            });
        } else {
            this.onSaveSuccess(lotUUID);
        }

    }

    private onSaveSuccess(result: any) {
        this.alertService.success('inventoryManagerApp.lot.create.success');
        this.eventManager.broadcast({ name: 'columnFiltersChanged', content: 'OK' });
        this.activeModal.dismiss(result);
    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

}

@Component({
    selector: 'jhi-lot-create-popup',
    template: ''
})
export class LotCreatePopupComponent implements OnInit, OnDestroy {

    routeSub: any;

    constructor(private inventoryService: InventoryService,
                private alertService: AlertService,
                private route: ActivatedRoute,
                private lotPopupService: LotPopupService
    ) {
    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.lotPopupService
                .open(LotCreateDialogComponent as Component);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }

}
